import React, { PropsWithChildren, useState } from 'react';
import { ToastItemOpts, ToastKey, ToastProviderContext } from './toast-properties';
import { ToastRenderer } from './toast-renderer';

import './toast.scss';

export const ToastProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, setState] = useState<{ items: ToastItemOpts[] }>({ items: [] });

  const enqueueToast = ({
    id,
    type,
    message,
    duration,
    isClosable
  }: ToastItemOpts): ToastKey => {
    // Add new toast
    const newToast = {
      id: id ?? 'toast-' + Math.random().toString(16).substring(1, 14),
      type,
      message,
      duration: duration ?? 3500,
      isClosable: isClosable ?? true
    };
    setState((prev) => ({ items: [...prev.items, newToast] }));
    // Starting fading out after duration
    setTimeout(() => {
      setState((prev) => ({
        items: prev.items.map((item) =>
          item.id === newToast.id ? { ...item, duration: 0 } : item
        )
      }));
    }, newToast.duration);
    // Remove toast after duration + 3 seconds (for fade out)
    setTimeout(() => {
      setState((prev) => ({
        items: prev.items.filter((item) => item.id !== newToast.id)
      }));
    }, newToast.duration + 2500);
    // Return the toast ID (not really sure why at this point)
    return newToast.id;
  };

  return (
    <ToastProviderContext.Provider value={{ enqueueToast }}>
      {children}
      <ToastRenderer items={state.items} />
    </ToastProviderContext.Provider>
  );
};
